import { ThemeConfig } from 'antd'
import PALLETTE from './pallette.module.scss'
const controlHeight = 50

const inputBgColor = '#282828';
const inputTextColor = '#ffffff';
const colorTextPlaceholder = 'rgba(255,255,255,0.5)';

const colorBorder = inputBgColor;
const colorLink = PALLETTE.primaryColor;

export const defaultTheme: ThemeConfig = {
  token: {
    controlHeight: 40,
    fontSize: 16,
    borderRadius: 8,
    fontFamily: 'Roboto',
    colorPrimary: PALLETTE.primaryColor,
    colorTextBase: '#ffffff',
    colorText: '#ffffff',
    colorLink: colorLink,
  },
  components: {
    Button: {
      controlHeight,
      colorTextLightSolid: '#000000',
    },
    Select: {
      controlHeight,
      colorBgContainer: inputBgColor,
      colorText: inputTextColor,
      colorTextPlaceholder: colorTextPlaceholder,
      colorBorder,
    },
    DatePicker: {
      controlHeight,
      colorBgContainer: inputBgColor,
      colorText: inputTextColor,
      colorTextPlaceholder: colorTextPlaceholder,
      colorBorder,
    },
    Input: {
      controlHeight,              
      colorBgContainer: inputBgColor,
      colorText: inputTextColor,
      colorTextPlaceholder: colorTextPlaceholder,
      colorBorder,
    },
    InputNumber: {
      controlHeight,
      colorBgContainer: inputBgColor,
      colorText: inputTextColor,
      colorTextPlaceholder: colorTextPlaceholder,
      colorBorder,
    },
    Layout: {
      headerColor: 'white',
    },
    Form: {
      verticalLabelPadding: '0 0 2px',
    },
  },
}
